module.exports = __webpack_public_path__ + "static/media/banner.f5b7fd36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/member/banner.jpg
// module id = 146
// module chunks = 0